import {Component} from 'react';
import {FormError} from './form-errors';
import {RadioBox} from './radiobox';
import {MontantInput} from './montant-input';
import {DisplayBox} from './displaybox';
import InfoBulle from './info';

class Logement extends Component {

	constructor (props) {
		super(props);
		this.state = {
			optionsVille :[],
			validations: {
				codePostal :[]
			},
			ville:0,
			situationLogement:null,
			codePostal : this.props.codePostal ? this.props.codePostal : null,
			codeInsee : null,
			codeEpci : null,
			regionCode : null,
			nomVille : null,
			siren : null,
			validationErrors : [],
			payeFraisLogement : null , //menage participation_frais
			primoAccedant : null,
			typeLocation : null,
			isColoc :null,
			proprietaireProcheFamille:null,
			isChambre :null,
			loyer:'',
			mensualites :'',
			chargeLocative:'',
			optionsTypeLocation : {
				'Non Meublé':'nonmeuble',
				'Meublé / hôtel': 'meublehotel',
				'Foyer' : 'foyer',
				'Résidence universitaire ' : 'universitaire',
				'EHPAD' : 'ehpad',
				'Logement social' : 'hlm',
			}

		};

		this.statusOccupationMap = {
      proprietaireprimoaccedant: 'primo_accedant',
      proprietaire: 'proprietaire',
      locatairenonmeuble: 'locataire_vide',
      locatairemeublehotel: 'locataire_meuble',
      heberge: 'loge_gratuitement',
      locatairefoyer: 'locataire_foyer',
      sansDomicile : 'sans_domicile',
      locataireuniversitaire : 'locataire_foyer',
      locataireehpad: 'locataire_foyer' ,
      locatairehlm : 'locataire_foyer',
    };

    this.erreurValidationMap = {
      payeFraisLogement : "Veuillez indiquer si vous participez aux frais de logement" ,
			primoAccedant : "Veuillez indiquer si vous êtes primo-accédant",
			typeLocation : "Veuillez renseigner le type de logement",
			isColoc :"Veuillez renseigner si vous êtes en colocation",
			proprietaireProcheFamille:"Veuillez renseigner si vous avez un lien de parenté avec votre propriétaire",
			isChambre :"Veuillez indiquer si votre logement est une chambre",
			loyer:"Veuillez indiquer votre loyer",
			chargeLocative:"Veuillez indiquer le montant de vos charges",
//			codeInsee:"Veuillez choisir une ville / commune avant de passer à l'étape suivante",
			situationLogement : "Veuillez renseigner votre situation de logement",
			codePostal : "Veuillez saisir un code postal valide.",
    };

		this.state.optionsSituationLogement = [
			{
              label: 'Locataire',
              value: 'locataire'
            },
            {
              label: 'Propriétaire',
              value: 'proprietaire'
            },
            {
              label: 'Hébergé (chez vos parents, chez un tiers...)',
              value: 'heberger'
            },
            {
              label: 'Sans domicile stable',
              value: 'sans_domicile'
            }
		];

		if (this.props.codePostal && this.props.ville){
				this.getCitiesFromPostalCode(this.props.codePostal , this.props.ville);
		}

	}

	checkRequiredDatas = ( requiredDatas) => {
		return requiredDatas.reduce( ( stillValid , dataName) => {
					if ( [undefined  , null , NaN , ""].includes(this.state[dataName]) ) {
						stillValid = false;
						this.setState( ({validationErrors})=>{
							
							const newErrors  = [ ...validationErrors, this.erreurValidationMap[dataName]];
							return {validationErrors : newErrors};
						});
					}
					return stillValid;
				} , true);
	}

	validateLogement  = () =>{
		var data = {
			menage : {},
			famille : {},
		};
		// Reset validation errors state 
		this.setState( ()=>({
			validationErrors : []
		}));

		var dataValid = this.checkRequiredDatas(["situationLogement"]);
		// validate data and assign variables to openfisca entity 
		if (dataValid){
			if ( this.state.situationLogement === "locataire") {
				const requiredDatas = ["isColoc" , "typeLocation" , "proprietaireProcheFamille" , "loyer" ];
				dataValid =this.checkRequiredDatas(requiredDatas);

				if (dataValid) {
					data.menage.coloc = JSON.parse(this.state.isColoc);
					data.famille.proprietaire_proche_famille = JSON.parse(this.state.proprietaireProcheFamille);

					/* Status occupation logement*/
					const userStatus = this.state.situationLogement+this.state.typeLocation;
					
					data.menage.statut_occupation_logement = this.statusOccupationMap[userStatus];

					/* Loyer */
					data.menage.loyer = this.state.loyer < 0 ? 0 : this.state.loyer;

					if ( this.state.typeLocation !== "meublehotel") {
						dataValid = this.checkRequiredDatas(['chargeLocative']);
						if (dataValid) data.menage.charges_locatives = this.state.chargeLocative < 0 ? 0 : this.state.chargeLocative ;
					}

					if (['nonmeuble', 'meubleholte'].includes(this.state.typeLocation) && dataValid) {
						dataValid = this.checkRequiredDatas(["isChambre"]);
						if (dataValid) data.menage.logement_chambre = JSON.parse(this.state.isChambre);
					}else{
						data.menage.logement_chambre = false;
					}
					
				}


			} else if ( this.state.situationLogement === "proprietaire") {
				const requiredDatas = ["primoAccedant" ];
				dataValid =this.checkRequiredDatas(requiredDatas);
				
				if (dataValid){
					const userStatus = this.state.situationLogement+ ( JSON.parse(this.state.primoAccedant)  ? 'primoaccedant' : '');
					data.menage.statut_occupation_logement = this.statusOccupationMap[userStatus];
					data.menage.charges_locatives =  ![undefined  , null , NaN , ""].includes(this.state.mensualites) ? this.state.mensualites : 0;
				}
			} else if ( this.state.situationLogement === "heberger") {
				dataValid = this.checkRequiredDatas( ["payeFraisLogement"] );

				if (dataValid) {
					data.menage.statut_occupation_logement = "loge_gratuitement";
					data.menage.participation_frais = JSON.parse(this.state.payeFraisLogement);
				}
			} else if ( this.state.situationLogement === "sans_domicile"){
				data.menage.statut_occupation_logement = "sans_domicile";
			} else {
				data.menage.statut_occupation_logement = "non_renseigne";
			}
		}

		if (dataValid)
			dataValid = this.checkRequiredDatas( ["codePostal" , "codeInsee"])

		if (dataValid) {
			
			data.menage.depcom = this.state.codeInsee ;
			data.menage.code_postal = this.state.codePostal;
			data.menage.codeEpci = this.state.codeEpci;
			data.menage.nomVille = this.state.nomVille;
			data.menage.regionCode = this.state.regionCode;
			data.menage.siren = this.state.siren;

			this.props.validateStep(data);
		}
	}

	/* Fetch data from API */
	getCitiesFromPostalCode = (code_postal , villeCodeInsee) =>{
		let urlAPI = "https://simulateurs.aide-sociale.fr/simulateur-aide-sociale/communes.php?code_postal=" + code_postal;
		this.setState(()=>({
			loadingVilles : true,
		}));


		fetch(urlAPI)
			.then((res)=> res.json())
			.then((json)=>{
				const cities = json;

				this.setState( ()=> {
					if (cities.length > 0 ){
						var index = 0 ;

						if (typeof villeCodeInsee !== 'undefined' && villeCodeInsee !== null){
							cities.forEach( (city , i) => {
								if (villeCodeInsee === city.code ) index  = i;
							});
						}
						
						const villeData = cities[index];
						const newCodeInsee = villeData.code;
						return {
							optionsVille:cities,
							ville : index,
							codeInsee:newCodeInsee,
							codeEpci : villeData.codeEpci,
							nomVille : villeData.nom,
							regionCode : villeData.codeRegion,
							siren : villeData.siren, 
							loadingVilles : false,
						};
						
					}
					return { 
						optionsVille : cities,
						loadingVilles :false
					}
				});
			});
	}
	
	/*Events Handlers*/
	handleChangeSituationLogement = (e)=> {
		const situation = e.target.value;
		this.setState( ()=>{
			return {situationLogement : situation };
		});
	}

	handleChangeCodePostal = (e)=>{
		const newCodePostal = e.target.value;
		if (newCodePostal.length < 6){
			let validationErrors =[];
			if (e.target.value.length >= 5){
				// appel API code postal
				this.getCitiesFromPostalCode(newCodePostal);
				

			}else{
				validationErrors.push(this.erreurValidationMap.codePostal);
			}

			this.setState(({validations})=>{
				validations.codePostal = validationErrors;
				return {
					validations : validations,
					codePostal : newCodePostal
				};
			});
		}
	}

	handleChangeVille = (e)=> {
		const villeData = this.state.optionsVille[e.target.value];
		const newCodeInsee = villeData.code;
		//console.log(villeData);
		this.setState(()=>{
			return {
				codeInsee:newCodeInsee,
				codeEpci : villeData.codeEpci,
				nomVille : villeData.nom,
				regionCode : villeData.codeRegion,
				siren : villeData.siren, 
			}
		});
	}

	handleRadioSwitch = (newValue , modelName)=>{

		this.setState( ()=>{
			var newState = {};
			newState[modelName] = newValue;
			return newState;
		});
	}

	handleMontantChange = (newValue , modelName)=>{
			this.setState( ()=>{
				var newState = {};
				newState[modelName] = newValue;
				return newState;
			});
	}
	
	/* Views */
	formLocataire = ()=>{
		const infoChambre= <p>Une chambre est un logement qui ne comporte qu'une seule pièce et n'est pas équipée d'un WC.</p>;
		
		const displayQuestionChambre = (
			this.state.typeLocation === 'meublehotel' ||
			this.state.typeLocation === 'nonmeuble'
		) ? true : null ;
		
		return <>
				<RadioBox 
					name="colocation" 
					options={{"Oui":true, "Non":false}} 
					handler={this.handleRadioSwitch}
					defaultValue={this.state.isColoc}
					modelName="isColoc"
				>Est-ce une colocation ?</RadioBox>
				<DisplayBox display={this.state.isColoc}>
					<RadioBox name="proprietaire_proche_famille"
						options={{"Oui":true , "Non":false}}
						handler={this.handleRadioSwitch}
						defaultValue={this.state.proprietaireProcheFamille}
						modelName="proprietaireProcheFamille"
					>
						Avez-vous un lien de parenté direct avec votre propriétaire ?<br/>
						<small>Est-il un ascendant ou descendant de vous ou votre conjoint·e (enfant, grand-parent…) ?</small>
					</RadioBox>
				</DisplayBox>

				<DisplayBox display={this.state.proprietaireProcheFamille} >
					<RadioBox name="typeLocation"
						options={this.state.optionsTypeLocation}
						handler={this.handleRadioSwitch}
						defaultValue={this.state.typeLocation}
						modelName="typeLocation"
					>Quel type de logement louez-vous ?</RadioBox>
				</DisplayBox>
				<DisplayBox display={displayQuestionChambre}>
					<RadioBox name="chambre"
						options={{"Oui":true, "Non":false}}
						handler={this.handleRadioSwitch}
						defaultValue={this.state.isChambre}
						modelName="isChambre"
					>Est-ce une chambre ? <InfoBulle message={infoChambre}/></RadioBox>
				</DisplayBox>
				
				<DisplayBox display ={this.state.typeLocation}>
				{ ( this.state.typeLocation !== 'meublehotel') ?
					<div className="fade-in">
						<MontantInput
							name="loyer"
							model={this.state.loyer}
							modelName="loyer"
							handler={this.handleMontantChange}
						 >Votre loyer (hors charges)</MontantInput>
						
						<MontantInput
							name="charges_locative"
							model={this.state.chargeLocative}
							modelName="chargeLocative"
							handler={this.handleMontantChange}
						 >Vos charges locatives</MontantInput>
					</div>
					:  <div className="loyer-container fade-in"><MontantInput
							name="loyer"
							model={this.state.loyer}
							modelName="loyer"
							handler={this.handleMontantChange}
						 >Votre loyer (charges comprises)</MontantInput></div>
				}
				</DisplayBox>
				

			</>;
	}

	formProprietaire = ()=>{
		return <>
			<RadioBox name="primoAccedant"
				options={{"Oui":true, "Non":false}}
				handler={this.handleRadioSwitch}
				defaultValue={this.state.primoAccedant}
				modelName="primoAccedant"
			>
				Êtes-vous primo-accédant pour cette propriété ?<br/>
				<small>Un primo-accédant est une personne (ou un ménage) qui n’a pas été propriétaire de sa résidence principale dans les deux années qui viennent de s’écouler au moment où il achète son bien</small>
			</RadioBox>
			<div className="loyer-container">
				<MontantInput
					name="mensualites"
					model={this.state.mensualites}
					modelName="mensualites"
					handler={this.handleMontantChange}
				 >
				 	Montant des mensualités <br/>
					<small>Laissez ce champ à 0 € si vous ne remboursez pas actuellement de crédit pour votre logement.</small>
				</MontantInput>
			</div>
		</>;
	}

	formHeberge = ()=>{
		return <>
			<RadioBox 
				name="payeFraisLogement" 
				options={{"Oui":true, "Non":false}} 
				handler={this.handleRadioSwitch}
				defaultValue={this.state.payeFraisLogement}
				modelName="payeFraisLogement"
			>Participez-vous aux frais de logement ?</RadioBox>
		</>;

	}

	formulaireLogement = ()=>{
		/* Formulaire afficher selon le status d'occupation choisi par l'utilisateur */
		if ( this.state.situationLogement === "locataire") {
			return this.formLocataire();
		} else if ( this.state.situationLogement === "proprietaire") {
			return this.formProprietaire();
		} else if ( this.state.situationLogement === "heberger") {
			return this.formHeberge();
		} else if ( this.state.situationLogement === "sans_domicile") {
			return <></>;
		}
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = ()=> {
		this.props.restart();
	}

	

	/*Render*/
	render () {

		const textCenter = {textAlign:'center'};
		const ville = this.state.ville;
		const infoMessage = <p>Si vous habitez actuellement &agrave; l'&eacute;tranger pr&eacute;f&eacute;rez plutot le simulateur
		<strong> <a href="https://www.service-public.fr/particuliers/vosdroits/F32823">retour en france</a> </strong>
		Des d&eacute;lais de r&eacute;sidence en france sont en effet requis pour certaines aides
		</p>;
		return <div className="etape-logement step-inner-container">
			<div className="question question-situation-logement">
				<h3 style={textCenter}>Mon Logement</h3>
				<p style={textCenter}> Si vous habitez à l’étranger : <InfoBulle message={infoMessage}/> </p>
				<select name="situation-logement"
					    className="select-situation-logement"
					    onChange={this.handleChangeSituationLogement}
					>
					<option value="" selected disabled>Sélectionnez votre situation de logement</option>
					{this.state.optionsSituationLogement.map((option)=>(
						<option value={option.value}>{option.label}</option>
					))}
				</select>
				
				{ ( this.state.situationLogement === 'locataire' )?
				<small className="textSituationLogement">figurant sur le bail ou en foyer de logement</small>
				:	''
				}
				
				{ ( this.state.situationLogement === 'heberger' )?
				<small className="textSituationLogement">chez un particulier ou en logement de fonction</small>
				:	''
				}

			</div>
			<div className="questions-logement">
			{ ( this.state.situationLogement) ?
				this.formulaireLogement()
			: ''
			}
			</div>

			<div className="question code-postal">
				<label><h3>Code Postal</h3></label>
				<input 
					type="text"
					name="code_postal"
					placeholder="Ex: 75015"
					value= {this.state.codePostal}
					onChange={this.handleChangeCodePostal}
				/>
				
				{(this.state.loadingVilles) ? <div className="loader loader-code-postal"></div> : ''}
			</div>
			{ ( this.state.optionsVille.length > 0 )?
				<div className="question selec-ville">
					<label><h3>Ville</h3></label>
					<select className="select-ville" defaultValue={ville} onChange={this.handleChangeVille}>
						
						{this.state.optionsVille.map((ville , index)=>(
							<option value={index}>{ville.nom}</option>
						)
						)}
					</select>
				</div>

			:''}
			<div className="error-container clear">
			  <FormError errors={this.state.validations.codePostal} ></FormError>
			  <FormError errors = {this.state.validationErrors}></FormError>
			</div>
			<button className="btn-validation" onClick={this.validateLogement}> Valider </button>
			<div className="button-container previous">
				<button onClick={this.restart}> Recommencer </button>
			</div>
		</div>;
	}
}

export default Logement;
